import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import { IOrganisationIndexCategory } from "../model/OrganisationIndexCategory";
import OrganisationIndexCategoryMapper from "../service/OrganisationIndexCategoryMapper";
import OrganisationIndexCategoryParamMapper from "../service/OrganisationIndexCategoryParamMapper";

export default class UpdateOrganisationIndexCategoryInteractor {
  private resource: UpdateResourceInteractor<IOrganisationIndexCategory>;

  constructor({ updateResource }: any) {
    this.resource = updateResource;
  }

  async execute(model: IOrganisationIndexCategory) {
    const result = await this.resource.execute(
      `organisations/${model.organisationId}/index-categories`,
      OrganisationIndexCategoryMapper,
      OrganisationIndexCategoryParamMapper,
      model,
      model.id,
      undefined,
      false
    );

    return result;
  }
}
